/*
 * @Date         : 2021-08-04 14:13:53
 * @LastEditors  : zhangxu
 * @LastEditTime : 2021-08-05 17:20:08
 * @FilePath     : /mvp/src/store/diagnoseCenter.ts
 */
import { Diagnose } from '@/interface/diagnose.interface'

interface State {
  tempCombTopicList: Diagnose.TempCombItem[]
  collectList: Diagnose.CollectItem[]
}

export default {
  namespaced: true,
  state: {
    tempCombTopicList: [], // 组合列表
    collectList: [], // 收藏列表
  },
  mutations: {
    setTempCombTopicList(state: State, payload: Diagnose.TempCombItem[]) {
      state.tempCombTopicList = [...(payload || [])]
    },
    setCollectList(state: State, payload: Diagnose.CollectItem[]) {
      state.collectList = [...(payload || [])]
    },
  },
}
